<div [ngSwitch]="type">
  <!-- Grouped Dropdown -->
  <div *ngSwitchCase="'group'">
    <div class="custom-dropdown">
      <div class="dropdown-label" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()" role="button"  tabindex="-1">
        <span class="label-text">
          {{ selectedLabel ? selectedLabel : (placeholder ? placeholder : ('dropdown.placeholder' | translate)) }}
        </span>
        <i *ngIf="selectedLabel" class="bi bi-x-square-fill reset-icon" (click)="reset()" role="button"  tabindex="-1" style="position: absolute; right: 2rem;"></i>
        <span class="dropdown-icon">&#9662;</span>
      </div>
      <div class="dropdown-menu" *ngIf="isOpen">
        <div class="filter-input" *ngIf="filter">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="searchText"
            [placeholder]="'dropdown.filter.placeholder' | translate"
            (input)="filterGroupOptions()"
          />
        </div>
        <div>
          <div class="dropdown-option">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="isAllGroupSelected()"
              (click)="toggleSelectAllGroup($event)" role="button"  tabindex="-1"
            />
            {{ "dropdown.all" | translate }}
          </div>
          <div *ngFor="let group of filteredOptions">
            <div class="dropdown-group-label">{{ group.label }}</div>
            <div
              *ngFor="let option of group.items"
              [ngClass]="{ selected: isSelected(option.value) }"
              class="dropdown-group-option"
            >
              <input
                type="checkbox"
                class="form-check-input"
                [checked]="isSelected(option.value)"
                (click)="toggleGroupOption(option, group)" role="button"  tabindex="-1"
              />

             <span class="option-label" > {{ option.label }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Single Dropdown -->
  <div *ngSwitchCase="'single'">
    <div class="custom-dropdown">
      <div class="dropdown-label" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()" role="button"  tabindex="-1">
        <span class="label-text">
          {{ selectedLabel ? selectedLabel : (placeholder ? placeholder : ('dropdown.placeholder' | translate)) }}
        </span>
        <i *ngIf="selectedLabel" class="bi bi-x-square-fill reset-icon" (click)="reset()" role="button"  tabindex="-1" style="position: absolute; right: 2rem;"></i>
        <span class="dropdown-icon">&#9662;</span>
      </div>
      <div class="dropdown-menu" *ngIf="isOpen">
        <div class="filter-input" *ngIf="filter">
          <input
            type="text"
            [(ngModel)]="searchText"
            class="form-control"
            [placeholder]="('dropdown.filter.placeholder' | translate)"
            (input)="filterOptions()"
          />
        </div>
        <div>
          <div class="dropdown-option">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="isAllSelected()"
              (click)="toggleSelectAll($event)" role="button"  tabindex="-1"
            />
            {{ "dropdown.all" | translate }}
          </div>
          <div
            *ngFor="let option of filteredOptions"
            [ngClass]="{ selected: isSelected(option.value) }"
            class="dropdown-option"
          >
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="isSelected(option.value)"
              (click)="toggleOption(option)" role="button"  tabindex="-1"
            />
            <span class="option-label" > {{ option.label }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- String Dropdown -->
  <div *ngSwitchCase="'string'">
    <div class="custom-dropdown">
      <div class="dropdown-label" [ngClass]="{'disabled': disabled}" (click)="toggleDropdown()" role="button"  tabindex="-1">
        <span class="label-text">
          {{ selectedLabel ? selectedLabel : (placeholder ? placeholder : ('dropdown.placeholder' | translate)) }}
        </span>
        <i *ngIf="selectedLabel" class="bi bi-x-square-fill reset-icon" (click)="reset()" role="button"  tabindex="-1" style="position: absolute; right: 2rem;"></i>
        <span class="dropdown-icon">&#9662;</span>
      </div>
      <div class="dropdown-menu" *ngIf="isOpen">
        <div class="filter-input" *ngIf="filter">
          <input
            type="text"
            [(ngModel)]="searchText"
            class="form-control"
            [placeholder]="('dropdown.filter.placeholder' | translate)"
            (input)="filterStringOptions()"
          />
        </div>
        <div>
          <div class="dropdown-option">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="isAllStringSelected()"
              (click)="toggleSelectAllString($event)" role="button"  tabindex="-1"
            />
            {{ "dropdown.all" | translate }}
          </div>
          <div
            *ngFor="let option of filteredOptions"
            [ngClass]="{ selected: isSelected(option) }"
            class="dropdown-option"
          >
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="isSelected(option)"
              (click)="toggleStringOption(option)" role="button"  tabindex="-1"
            />
            <span class="option-label" > {{ option }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
